import AppHeader from '../app/appHeader';
import React, { useEffect, useState } from 'react';
import { Link, Typography } from '@getgo/chameleon-web/react';
import API from '../utils/api';
import { eventDataViewModel } from '../utils/eventDataFormat';
import { useEventContext } from '../context/eventContext';
import { useParams } from 'react-router';
import { IEventUrlParameters } from '../event/eventInterface';
import Footer from '../footer/footer';
import MailToUtils from '../../utils/MailToUtils';
import { setCookie } from '../utils/browserCookies';
import './cancelRegistration.scss';
import { Trans, useTranslation } from 'react-i18next';
import FullScreenLoader from '../utils/fullScreenLoader/FullScreenLoader';

const CancelRegistration = () => {
  const { t, i18n } = useTranslation();
  const { eventId, eventRegistrationId } = useParams<IEventUrlParameters>();
  const [isLoading, setLoading] = useState(true);
  const { setEventDetails, eventDetails } = useEventContext();

  useEffect(() => {
    const cancelEvent = async () => {
      await API.cancelRegisteredEvent(eventRegistrationId || '');
      setCookie(eventId, null, new Date(), -7);
    };
    cancelEvent();
  }, [eventRegistrationId, eventId]);

  useEffect(() => {
    const getEvent = async () => {
      const eventData = await API.getEventDetails(eventId || '');
      const lang = eventData?.data?.locale?.substr(0, 2).toLowerCase() || 'en';
      if (lang && lang !== i18n.language) {
        i18n.changeLanguage(lang, () => {
          let langCopy = lang;
          if (langCopy === 'zh') {
            langCopy = 'zh-cn';
          }
          // TO-DO Change language for date
          document.documentElement.lang = langCopy;
        });
      }
      if (eventData.status === 200) {
        setEventDetails(eventDataViewModel(eventData.data));
      }
    };
    getEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId, setEventDetails]);

  useEffect(() => {
    if (eventDetails?.locale.includes(i18n.language)) {
      setLoading(false);
    }
  }, [eventDetails?.locale, i18n.language]);

  return isLoading ? (
    <FullScreenLoader />
  ) : (
    <div className="registration-grid">
      <AppHeader />
      <div className="registration">
        <div className="box">
          <div className="box-space">
            <div>
              <Typography color="text-01" variant="heading-large">
                {t('cancelRegistration.title')}
              </Typography>
            </div>
            <div className="registration-description">
              <Typography color="text-01" variant="body-large">
                <Trans i18nKey="cancelRegistration.description">
                  Your registration has been canceled. Please
                  <Link href={MailToUtils.createLink(eventDetails?.organizers?.[0]?.email ?? '')}>
                    contact the organizer
                  </Link>
                  with any further questions.
                </Trans>
              </Typography>
            </div>
          </div>
          <div>
            <Typography color="text-01" variant="body-large">
              <Trans i18nKey="cancelRegistration.goToEventPage">
                Canceled accidentally?
                <Link href={`/event/${eventId}`}>Go to the event page</Link>
              </Trans>
            </Typography>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CancelRegistration;
